import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./MobileDesktopWarning.css";
import useMobileDetect from "../../hooks/useMobileDetect";

const MobileDesktopWarning: React.FC = () => {
  const [showWarning, setShowWarning] = useState(false);
  const location = useLocation();
  const isMobile = useMobileDetect();

  useEffect(() => {
    // Check if warning has been dismissed before
    const isDismissed = localStorage.getItem("mobileDesktopWarningDismissed");

    // Check if current path is in excluded pages (exact match for root, or matching start for others)
    const isExcludedPage =
      location.pathname === "/" ||
      location.pathname.startsWith("/planselection");
    // Show warning if:
    // 1. User is on mobile AND warning hasn't been dismissed AND not on excluded page
    const shouldShow = isMobile === true && !isDismissed && !isExcludedPage;

    setShowWarning(shouldShow);
  }, [isMobile, location.pathname]);

  const handleDismiss = () => {
    localStorage.setItem("mobileDesktopWarningDismissed", "true");
    setShowWarning(false);
  };

  if (!showWarning) return null;

  return (
    <div className="mobile-desktop-warning-overlay">
      <div className="mobile-desktop-warning-container">
        <div className="warning-icon-container">
          <div className="warning-icon pulse">
            <svg
              width="80"
              height="80"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
            >
              <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
              <line x1="8" y1="21" x2="16" y2="21"></line>
              <line x1="12" y1="17" x2="12" y2="21"></line>
            </svg>
          </div>
        </div>

        <div className="warning-content">
          <h1>✨ Good Things Need Space</h1>

          <p className="warning-message">
            Your work deserves a full desktop experience. We've designed every
            pixel for the big screen.
          </p>

          <p className="warning-subtitle">
            Open this on your desktop or laptop for the best experience.
          </p>
        </div>

        <div className="warning-actions">
          <button className="action-button primary" onClick={handleDismiss}>
            Got It, Continue Anyway
          </button>
        </div>
      </div>
    </div>
  );
};

export default MobileDesktopWarning;
